<template>
    <v-card elevation="1" class="ticket-container rounded-lg mt-4 px-4 py-3" :class="cssClasses">
        <ticket-status-header
            :geography="geography"
            :category-name="categoryName"
            :status="status"
            :validity-time="validityTime"
            :name="name"
            :order-time="orderTime"
            :is-started="isStarted"
            :now="now"
        />
        <div v-if="validityTime" class="ticket-alert pt-2">
            <div class="text-caption text-medium-emphasis d-flex">
                <span v-if="isStarted === false" class="ticket-alert-message">
                    <strong>{{ t('travelCard.remember', 'Remember') }}!</strong>
                    {{ t('travelCard.newTicketUsageDescription', 'Description about new tickets.') }}
                </span>
            </div>
        </div>
    </v-card>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CardProductDto } from '@/types/webapi';
import TicketStatusHeader from './TicketStatusHeader.vue';

const props = withDefaults(defineProps<CardProductDto & { now?: Date }>(), { now: () => new Date() });

const { t } = useI18n();

const isActive = computed(() => !!props.validityTime && props.isStarted);
const cssClasses = computed(() => ({
    'ticket-container--active': isActive.value
}));
</script>

<style lang="scss">
.ticket-container--active {
    border: 1px solid var(--v-color-green);
    background-color: var(--v-color-green-50);
}
</style>
